module.exports = __webpack_public_path__ + "img/img-top.cccf1582.png";